import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faSort,
    faSortUp,
    faSortDown,
    faChevronLeft,
    faChevronRight,
    faSpinner,
    faImage,
    faFile,
    faPaperPlane,
    faArrowLeft,
    faCheck,
    faTimes,
    faPlus,
    faLock,
    faHistory,
    faTrash,
    faTrashRestore,
    faInfoCircle,
    faClock
} from '@fortawesome/free-solid-svg-icons';

library.add(
	faSort,
    faSortUp,
    faSortDown,
    faChevronLeft,
    faChevronRight,
    faSpinner,
    faImage,
    faFile,
    faPaperPlane,
    faArrowLeft,
    faCheck,
    faTimes,
    faPlus,
    faLock,
    faHistory,
    faTrash,
    faTrashRestore,
    faInfoCircle,
    faClock
);
